











import DesktopNavigation from 'library/components/layout/header/desktop/desktop-header'
import MobileNavigation from 'library/components/layout/header/mobile/index'

export default

	components: {
		DesktopNavigation
		MobileNavigation
	}

	computed: loaded: -> !!@$store.state.globals.desktopNavigation

